import Banner from "../components/common/banner/banner";
import BottomNavbar from './../components/common/bottomNavbar/bottomNavbar';
import { useTranslation } from "react-i18next";
import ProductCenter from './../components/product/productCener';
import { Helmet } from "react-helmet";

export default function CementBrick() {
    const {t} = useTranslation()
    return (
        <div>
            <Helmet>
                <title>{t('title.brick')}</title>
            </Helmet>
           <Banner 
           urlBanner="/BricksBgImg.jpg"
           titleBanner={t('banner.brick')}
            />
            <BottomNavbar
                currentPage={t('navbar.dropdowns.8')}
                mainPage={t('navbar.links.3')}
                mainUrl="/Marine-Cement"
            />
            <ProductCenter
                current={2}
            />
        </div>
    )
}